import { interpolate } from "../utils/string_utils";

export default class MatchingBalance {
  constructor(bankTransactions, purchaseInvoices, salesInvoices) {
    this.bankTransactions = bankTransactions;
    this.purchaseInvoices = purchaseInvoices;
    this.salesInvoices = salesInvoices;
  }

  get bankTransactionsAmount() {
    return this._sum(this.bankTransactions);
  }

  get purchaseInvoicesAmount() {
    return this._sum(this.purchaseInvoices);
  }

  get salesInvoicesAmount() {
    return this._sum(this.salesInvoices);
  }

  get balanceAmount() {
    return this.bankTransactionsAmount + this.purchaseInvoicesAmount - this.salesInvoicesAmount;
  }

  get balanceAmountClass() {
    return this.isBalanceAcceptable ? "color_green-alt" : "color_alt-red";
  }

  get badge() {
    if (this.balanceAmount === 0) {
      return "";
    }

    const badgeTemplate = document.getElementById("matching-balance-badge-template");

    if (this.isBalanceAcceptable && this._foreignCurrencySelected()) {
      return interpolate(badgeTemplate, {
        badgeClass: "badge-gray",
        badgeLabel: this.balanceAmount > 0 ? "Gain de change" : "Perte de change",
      });
    } else if (this.isBalanceAcceptable) {
      return interpolate(badgeTemplate, {
        badgeClass: "badge-success",
        badgeLabel: "Écart acceptable",
      });
    } else {
      return interpolate(badgeTemplate, {
        badgeClass: "badge-warning",
        badgeLabel: "Écart important",
      });
    }
  }

  get isBalanceAcceptable() {
    if (this._noBankTransactionSelected() || this._noCounterpartsSelected()) {
      return false;
    }

    return Math.abs(this.balanceAmount) <= this._maxBalanceAmount();
  }

  _maxBalanceAmount() {
    return Math.max(Math.abs(this.bankTransactionsAmount * 0.05), 3);
  }

  _sum(operations) {
    return operations.reduce((acc, operation) => {
      return acc + operation.amount;
    }, 0);
  }

  _noBankTransactionSelected() {
    return this.bankTransactions.length === 0;
  }

  _noCounterpartsSelected() {
    return this.purchaseInvoices.length === 0 && this.salesInvoices.length === 0;
  }

  _foreignCurrencySelected() {
    const operations = [...this.bankTransactions, ...this.purchaseInvoices, ...this.salesInvoices];
    return operations.some((operation) => operation.foreign_currency === true);
  }
}
